import { Theme } from '@mui/material'

export const getHeaderResponsiveStyles = (theme: Theme) =>
  ({
    container: {
      display: 'grid',
      gridTemplateColumns: '1fr auto 1fr',
      alignItems: 'center',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr auto',
        gridTemplateRows: 'auto auto',
        gap: '4px 0',
      },
    },
    leftBox: {
      justifySelf: 'start',
      [theme.breakpoints.down('sm')]: {
        gridColumn: '1',
        gridRow: '1 / 3',
        alignSelf: 'center',
      },
    },
    centerBox: {
      justifySelf: 'center',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        gridColumn: '2 / 4',
        gridRow: '1',
        justifySelf: 'start',
        ml: 1,
        overflow: 'hidden',
      },
    },
    /** スマホ2行目: マイク・薬剤師・メモトグル */
    actionsRow: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        gridColumn: '2 / 4',
        gridRow: '2',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 1,
        ml: 1,
      },
    },
    rightBox: {
      justifySelf: 'end',
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    patientName: {
      fontSize: '1.25rem',
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    },
  } as const)
